import { type FormatInTzOptions, formatEST } from '@dte/otw-utils-dates/src/format/formatEST';

export enum DateFormatType {
	Long = 'long',
	Short = 'short',
	Map = 'map',
	Audio = 'audio',
}

const formatForDate: Record<DateFormatType, string> = {
	[DateFormatType.Long]: 'EEEE, MMMM d',
	[DateFormatType.Short]: 'MMM d',
	[DateFormatType.Map]: 'MMM d, yyyy',
	[DateFormatType.Audio]: 'EEEE, MMMM d',
};
const formatForTimeWithMinutes: Record<DateFormatType, string> = {
	[DateFormatType.Long]: 'h:mm a',
	[DateFormatType.Short]: 'h:mm a',
	[DateFormatType.Map]: 'h:mm a',
	[DateFormatType.Audio]: 'h:mm a',
};
const formatForTimeWithoutMinutes: Record<DateFormatType, string> = {
	[DateFormatType.Long]: 'h a',
	[DateFormatType.Short]: 'h a',
	// Map always needs to include minutes
	[DateFormatType.Map]: 'h:mm a',
	[DateFormatType.Audio]: 'h a',
};
const useApStyleShortMonth: Record<DateFormatType, boolean> = {
	[DateFormatType.Long]: false,
	// Short format is the only one that we want to truncate using AP sytle
	[DateFormatType.Short]: true,
	[DateFormatType.Map]: false,
	[DateFormatType.Audio]: false,
};

export function formatEstimateDate(
	date: Date | undefined,
	dateFormat: DateFormatType = DateFormatType.Long,
	options?: FormatInTzOptions,
): string | undefined {
	const mergedOptions: FormatInTzOptions = {
		...options,
		useAPStyleShortMonth: useApStyleShortMonth[dateFormat],
	};

	return formatEST(date, formatForDate[dateFormat], mergedOptions);
}

export function formatEstimateTime(
	date: Date | undefined,
	dateFormat: DateFormatType = DateFormatType.Long,
	includeMinutes = true,
): string | undefined {
	if (includeMinutes) {
		return formatEST(date, formatForTimeWithMinutes[dateFormat]);
	}

	return formatEST(date, formatForTimeWithoutMinutes[dateFormat]);
}
